<ng-template #infoSectionTitle let-info="info">
  <div style="overflow-wrap: break-word; display: block; width: fit-content;  ">
    <joi-input #sectionTitle [disabled]="readonly" class="fit" [(model)]="info.title" placeholder="Section title" type="textarea" (joiChange)="saveInfo()" (click)="$event.stopPropagation()" ></joi-input>
  </div>
</ng-template>
<information
  #informationComponent
  [information]="information"
  [readOnly]="readonly || !event || event.is_readonly"
  [noItemsMessage]="noItemsMessage"
  [singleSectionOnly]="singleSectionOnly"
  [sectionTitleTemplate]="infoSectionTitle"
  [mobileCollapse]="mobileCollapse"
  [allCollapse]="allCollapse"
  [entityType]="entityType"
  [entityTypesMap]="entityTypesMap"
  (addSection)="addSection()"
  (dropSection)="dropSection($event)"
  (addItem)="addItem($event)"
  (duplicateSection)="duplicateSection($event)"
  (saveInfo)="saveSection($event)"
  (openItem)="openItem($event)"
  (dropItem)="dropItem($event)"
  (deleteInfo)="deleteSection($event)"
></information>
